<template lang="pug">
.rating-header
  .rating-header__image(:class="classImageType")
    img(:src="imageBg")
  .rating-header__title(v-html="text")
</template>

<script>
export default {
  name: "RatingHeader",
  props: {
    type: {
      type: String,
      default: "bronze",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    classImageType() {
      return `rating-header__image--${this.type}`;
    },
    imageBg() {
      return require(`@/assets/images/rating/rating-header-${this.type}.png`)
    },
  },
};
</script>
